import { ChangeDetectionStrategy, Component, input, output, signal, WritableSignal } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
// FIXME this dependency should be reviewed it causes an app crash
import { ProgressBarButtonModule } from '../../../../../iot-platform/iot-platform-ui/src/lib/components/progress-bar-button/progress-bar-button.module';
import { AuthValidators } from '../../validators/auth.validator';
import { LoginPasswordRulesComponent } from '../login-password-rules/login-password-rules.component';

@Component({
  imports: [
    TranslatePipe,
    MatIconModule,
    ReactiveFormsModule,
    MatTooltip,
    MatInput,
    LoginPasswordRulesComponent,
    ProgressBarButtonModule,
    MatButtonModule,
    MatFormFieldModule
  ],
  selector: 'iot-platform-login-reset-password-form',
  templateUrl: './login-reset-password-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./login-reset-password-form.component.scss', '../../scss/style.scss']
})
export class LoginResetPasswordFormComponent {
  form: FormGroup<{
    code: FormControl<string | null>;
    password: FormControl<string | null>;
    confirmPassword: FormControl<string | null>;
  }>;
  enableGauge: WritableSignal<boolean> = signal(false);
  password: WritableSignal<string | null> = signal(null);

  username = input<string>();
  /** Error message of the failed password update (e.g. the raw Cognito message), if any. */
  hasError = input<string>();

  // eslint-disable-next-line  @angular-eslint/no-output-native
  cancel = output();
  sendCode = output<string>();
  changePassword = output<{ username: string; code: string; password: string }>();

  constructor() {
    this.form = new FormGroup({
      code: new FormControl<string | null>(null, [Validators.required]),
      password: new FormControl<string | null>(null, [Validators.required, AuthValidators.checkPassword, this.checkConfirmPassword.bind(this)]),
      confirmPassword: new FormControl<string | null>(null, [Validators.required, this.checkConfirmPassword.bind(this)])
    });
  }

  get codeControl(): FormControl<string | null> {
    return this.form.controls.code;
  }

  get passwordControl(): FormControl<string | null> {
    return this.form.controls.password;
  }

  get confirmPasswordControl(): FormControl<string | null> {
    return this.form.controls.confirmPassword;
  }

  get errorPassword(): ValidationErrors | null {
    return this.form.getError('format', ['password']);
  }

  sendPasswordToRules(value: string | null): void {
    this.password.set(value);
  }

  checkConfirmPassword(control: AbstractControl): ValidationErrors | null {
    if (!this.form) {
      return null;
    }
    const password = this.form.controls.password;
    const confirmPassword = this.form.controls.confirmPassword;
    const errorsOrNull = confirmPassword.value === password.value ? null : { different: true };

    if (control === this.passwordControl) {
      this.confirmPasswordControl.setErrors(errorsOrNull);
      this.confirmPasswordControl.markAsDirty();
      return null;
    }

    return errorsOrNull;
  }

  onCancel() {
    this.cancel.emit();
  }

  onSendCode($event: Event) {
    $event.stopPropagation();
    this.sendCode.emit(this.username() ?? '');
  }

  onChangePassword() {
    this.changePassword.emit({
      username: this.username() ?? '',
      code: this.codeControl.value ?? '',
      password: this.passwordControl.value ?? ''
    });
  }
}
